import gql from "graphql-tag";

const userFieldsFragment = gql`
  fragment UserDTOFields on UserDTO {
    id
    version
    status
    fastLogin
    contact {
      id
      version
      firstName
      middleName
      lastName
      photoId
      emails {
        id
        version
        address
        status
        tags
      }
      addresses {
        id
        version
        city
        country
        line1
        state
        tags
        zipCode
      }
      phones {
        id
        version
        phoneNumber
        tags
      }
    }
    groups {
      id
      version
      name
      description
      status
    }
    userBusinesses {
      id
      version
      contact {
        id
        version
        companyName
      }
    }
  }
`;

const findApplicationUserByIdQuery = gql`
  query($id: UUID) {
    findApplicationUserById(id: $id) {
      ...UserDTOFields
    }
  }
  ${userFieldsFragment}
`;

const findApplicationUserByIdAndUBQuery = gql`
  query findApplicationUserByIdAndUB($id: UUID) {
    findApplicationUserByIdAndUB(id: $id) {
      ...UserDTOFields
    }
  }
  ${userFieldsFragment}
`;

const findApplicationUsersByNameQuery = gql`
  query findApplicationUsersByName(
    $office: OfficeInput
    $name: String
    $startIndex: Int
    $stopIndex: Int
  ) {
    findApplicationUsersByName(
      office: $office
      name: $name
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: {
          orders: [
            { direction: "ASC", property: "status" }
            { direction: "ASC", property: "contact.lastName" }
            { direction: "ASC", property: "contact.firstName" }
          ]
        }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        contact {
          id
          version
          firstName
          lastName
          photoId
          addresses {
            id
            version
            city
            country
            line1
            state
            tags
            zipCode
          }
          phones {
            id
            version
            phoneNumber
            tags
          }
        }
      }
    }
  }
`;

const saveApplicationUserMutation = gql`
  mutation($userDTO: UserDTOInput) {
    saveApplicationUser(userDTO: $userDTO) {
      ...UserDTOFields
    }
  }
  ${userFieldsFragment}
`;

const saveApplicationUserUBMutation = gql`
  mutation saveApplicationUserUB($userDTO: UserDTOInput) {
    saveApplicationUserUB(userDTO: $userDTO) {
      ...UserDTOFields
    }
  }
  ${userFieldsFragment}
`;

const emailNewUserMutation = gql`
  mutation($emailAddress: String, $password: String) {
    emailNewUser(emailAddress: $emailAddress, password: $password) {
      id
    }
  }
`;

const emailQRCode = gql`
  mutation emailQRCode($email: String) {
    emailQRCode(email: $email) {
      id
    }
  }
`;

const deleteApplicationUserMutation = gql`
  mutation($userDTO: UserDTOInput) {
    deleteApplicationUser(userDTO: $userDTO) {
      id
      version
    }
  }
`;

const findRepeatedEmailQuery = gql`
  query findRepeatedEmail (
    $emailAddress: String
    $notId: String
  ) {
    findRepeatedEmail (
      emailAddress: $emailAddress
      notId: $notId
    ) {
      id
      address
    }
  }
`;

const changeBusinessMutation = gql`
  mutation changeUserBusiness (
    $businessId: String
    $userId: String
  ) {
    changeUserBusiness (
      businessId: $businessId
      userId: $userId
    ) {
      ...UserDTOFields
    }
  }
  ${userFieldsFragment}
`;

const findApplicationUsersByUserBusinessQuery = gql`
  query findApplicationUsersByUserBusiness(
    $business: BusinessInput
    $name: String
    $startIndex: Int
    $stopIndex: Int
  ) {
    findApplicationUsersByUserBusiness(
      business: $business
      name: $name
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: {
          orders: [
            { direction: "ASC", property: "status" }
            { direction: "ASC", property: "contact.lastName" }
            { direction: "ASC", property: "contact.firstName" }
          ]
        }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        contact {
          id
          version
          firstName
          lastName
          photoId
          addresses {
            id
            version
            city
            country
            line1
            state
            tags
            zipCode
          }
          phones {
            id
            version
            phoneNumber
            tags
          }
        }
      }
    }
  }
`;

export {
  findApplicationUserByIdQuery,
  findApplicationUsersByNameQuery,
  saveApplicationUserMutation,
  emailNewUserMutation,
  deleteApplicationUserMutation,
  findRepeatedEmailQuery,
  emailQRCode,
  changeBusinessMutation,
  findApplicationUsersByUserBusinessQuery,
  findApplicationUserByIdAndUBQuery,
  saveApplicationUserUBMutation
};
